/**
 * UTF-8 Encoding.
 *
 *
 * @beta
 */
export const UTF_8 = 'utf-8'
